import { notification } from "antd";
import { IconType } from "antd/lib/notification";

export default (message: string, kind: IconType = "info"): void =>
  notification[kind]({ message, duration: 5 });
